<template>
  <div>
    <div class="vx-col w-full">
      <ul class="heading-ul mb-5">
        <li>
          <router-link :to="{ name: 'Pre Plan' }" class="vx-row">
            <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
            <h4>{{ $t("setup.label.CreateProductChannelMapping") }}</h4>
          </router-link>
        </li>
      </ul>
    </div>
    <ValidationObserver ref="observer">
      <div class="vx-row">
        <vx-card title card-border>
          <div class="vx-row">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label font-semibold"
                  >{{ $t("setup.label.ProductId")
                  }}<span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.ProductId')"
                >
                  <v-select
                    v-model="productMapping.productId"
                    :options="productDatas"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :reduce="(option) => option.value"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mb-2"
                  >
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <small class="date-label font-semibold">{{
                $t("setup.label.AvailableChannels")
              }}</small>
              <div
                class="w-full"
                style="height: 25rem; overflow: auto; padding: 2rem"
              >
                <table class="w-full">
                  <vs-tr
                    :key="availableChannel.id"
                    :data="availableChannel"
                    @click.stop="selectProduct(index)"
                    v-for="(availableChannel, index) in availableChannels"
                  >
                    <vs-td :data="availableChannel.id"
                      >{{ availableChannel.channelName }}
                    </vs-td>
                    <vs-td>
                      <div
                        style="
                          margin-left: 5rem;
                          margin-top: 0.3rem;
                          text-align: right;
                        "
                        v-if="!addedProducts[index]"
                      >
                        <vs-button
                          icon-pack="feather"
                          icon="icon-plus"
                          size="small"
                          style="width: 10rem; border-radius: 50%"
                          type="border"
                          @click="addUser(index)"
                        ></vs-button>
                        <!-- <vs-checkbox v-model="addedProducts[index]"></vs-checkbox> -->
                      </div>
                      <div v-else style="margin-left: 5rem; margin-top: 0.3rem">
                        <vs-button
                          icon-pack="feather"
                          icon="icon-check"
                          class="mb-2"
                          color="success"
                          style="border-radius: 50%; width: 2rem"
                          @click="removeUser(index)"
                          size="small"
                        ></vs-button>
                      </div>
                    </vs-td>
                  </vs-tr>
                </table>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="w-full">
                <small class="date-label font-semibold">{{
                  $t("setup.label.SelectedChannels")
                }}</small>
                <div
                  class="w-full"
                  style="height: 25rem; overflow: auto; padding: 2rem"
                >
                  <vs-table description :data="selectedProducts">
                    <template slot-scope="{ data }">
                      <vs-tr
                        :key="selectedUser.id"
                        :data="selectedUser"
                        @click.stop="selectProduct(index)"
                        v-for="(selectedUser, index) in data"
                      >
                        <vs-td :data="selectedUser.channelName"
                          >{{ selectedUser.channelName }}
                        </vs-td>
                        <vs-td>
                          <div>
                            <vs-button
                              icon-pack="feather"
                              icon="icon-x"
                              class="mb-2"
                              color="warning"
                              type="border"
                              style="border-radius: 50%"
                              @click="
                                removeUser(
                                  userNames.indexOf(selectedUser.channelName)
                                )
                              "
                              size="small"
                            ></vs-button>
                          </div>
                        </vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                </div>
              </div>
            </div>
          </div>
        </vx-card>
      </div>
      <div class="vx-row center">
        <div class="vx-col w-full">
          <vs-button
            color="primary"
            type="border"
            class="mb-2 footerButton-cancel"
            @click="cancel"
            >{{ $t("admin.label.Cancel") }}</vs-button
          >
          <vs-button
            class="mr-3 mb-2 footerButton-next"
            @click="createTeamUserData"
            >{{ $t("admin.label.Submit") }}</vs-button
          >
        </div>
      </div>
    </ValidationObserver>
    <validation-popup
      :errorMessage="errorMessage"
      :warningPopup="warningPopup"
      :warningText="warningText"
      @closeWarning="warningPopup = false"
    ></validation-popup>
  </div>
</template>
<script>
import vSelect from "vue-select";
import { mapState } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";

const ticketEmptyObj = {
  locale: "en",
  productId: "",
  channelDetail: [],
};

export default {
  data() {
    return {
      warningPopup: false,
      warningText: "",
      errorMessage: "",
      productMapping: ticketEmptyObj,
      added: false,
      statuses: ["ACTIVE", "INACTIVE"],
      checked: true,
      data: {},
      addedProducts: [],
      userIds: [],
      userNames: [],
      teamIds: [],
      teamCodes: [],
      availableChannels: [],
      selectedProducts: [],
      selectedUserIds: [],
      productDatas: [],
      iconSel: "icon-plus",
      username: "",
      teamCode: "",
    };
  },
  components: {
    ValidationProvider,
    ValidationObserver,
    "v-select": vSelect,
  },
  computed: {
    ...mapState({
      channelMappingTemplate: (state) =>
        state.broadcaster.channelMappingTemplate,
    }),
  },
  methods: {
    selectProduct(index) {
      this.selectedProducts.push(this.availableChannels[index]);
    },
    addUser(index) {
      if (this.selectedProducts.indexOf(this.availableChannels[index]) != -1) {
        this.removeUser(index);
      } else {
        this.addedProducts[index] = true;
        this.selectedProducts.push(this.availableChannels[index]);
        this.availableChannels[index].icon = "icon-check";
        this.selectedUserIds.push(this.availableChannels[index].id);
      }
    },

    removeUser(index) {
      this.addedProducts[index] = false;
      let indx = this.selectedProducts.indexOf(this.availableChannels[index]);
      this.selectedProducts.splice(indx, 1);
      this.selectedUserIds.splice(indx, 1);
    },
    async createTeamUserData() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;

      if (this.selectedProducts.length == 0) {
        this.warningPopup = true;
        this.warningText = "Please select channels";
        return;
      }

      this.productMapping.channelDetail = this.selectedUserIds;
      try {
        await this.$store.dispatch(
          "broadcaster/createProductMappingAction",
          this.productMapping
        );
        this.$swal({
          title: "Success",
          icon: "success",
          text: "ProductMapping Created Successfully!",
          type: "success",
        });
        this.$router.push({ name: "Pre Plan" });
        this.resetForm();
      } catch (e) {
        this.errorMessage = e.message.replace("The parameter", "");

        this.warningPopup = true;
        this.errors = e.message.errors;
      }
    },
    async getproductMappingTemplate() {
      try {
        await this.$store.dispatch("broadcaster/setChannelMappingTemplate");
        this.data = this.channelMappingTemplate;
        this.availableChannels = this.channelMappingTemplate.availableChannels;

        let j = 0;
        for (let temp of this.channelMappingTemplate.productDatas) {
          this.productDatas = [...this.productDatas, { label: "", value: "" }];
          this.productDatas[j].value = temp.id;
          this.productDatas[j].label = temp.productCode;
          j += 1;
        }
        for (let tempChannel of this.availableChannels) {
          if (
            this.availableChannels[this.availableChannels.indexOf(tempChannel)]
              .icon == undefined
          )
            this.availableChannels[
              this.availableChannels.indexOf(tempChannel)
            ].icon = "icon-plus";

          this.userNames.push(tempChannel.channelName);
          this.userIds.push(tempChannel.id);
        }
      } catch (e) {
        this.$toasted.error(e.message);
      }
    },
    resetForm() {
      this.productMapping = ticketEmptyObj;
      this.selectedProducts = [];
      this.addedProducts = [];
      this.productMapping.productId = "";
    },
    cancel() {
      this.$router.push({ name: "Pre Plan" });
    },
  },
  mounted() {
    this.resetForm();
    this.getproductMappingTemplate();
  },
};
</script>
<style>
select {
  padding: 5px 35px 5px 5px;
  border-radius: 0.3rem;
  color: rgb(132, 132, 132);
  font-size: 1.01rem;
  border: 1px solid rgb(208, 208, 208);
  height: 2.7rem;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}
</style>
